import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import SiteLayout from "@/components/SiteLayout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Qualify from "@/pages/Qualify";
import Portal from "@/pages/Portal";
import Logbook from "@/pages/Logbook";
import LogbookPost from "@/pages/LogbookPost";
import Onboarding from "@/pages/Onboarding";
import NotFound from "@/pages/NotFound";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Hidden onboarding hub — NOT linked from main navigation */}
          <Route path="/onboarding" element={<Onboarding />} />

          {/* Client Portal — dummy locked login, outside main nav chrome */}
          <Route path="/portal" element={<Portal />} />
          <Route path="/login" element={<Portal />} />

          {/* Public site */}
          <Route element={<SiteLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/qualify" element={<Qualify />} />
            <Route path="/inquiry" element={<Qualify />} />
            <Route path="/logbook" element={<Logbook />} />
            <Route path="/logbook/:slug" element={<LogbookPost />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
